import React from 'react';

interface Props {
  className?: string;
  size?: number | string;
  fill?: string;
}

export const JupiterOneIcon = ({
  size = 24,
  fill = 'white',
  ...otherProps
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M21.1185 19.7884C16.8195 24.821 9.24074 25.4418 4.2104 21.1186C3.72288 20.6973 3.27968 20.2539 2.8808 19.7884H21.1185Z"
        fill={fill}
      />
      <path
        d="M23.955 11.0089H15.4234C14.8472 10.9867 14.2489 11.0532 13.6949 11.1862C13.296 11.3193 12.9193 11.5188 12.5869 11.7627L12.5426 11.7848C11.0136 12.7825 9.41803 13.8245 7.53443 14.3344C6.35994 14.6448 5.1633 14.667 4.01097 14.667H3.63425H0.310242C0.576163 15.8198 1.01936 16.9505 1.61769 17.9704H22.4038C23.4675 16.1524 24.0215 14.0684 23.9994 11.9622C23.9994 11.6518 23.9772 11.3414 23.955 11.0089ZM19.7225 14.6226C19.7225 15.7755 18.7696 16.7288 17.6173 16.7288C16.4649 16.7288 15.5121 15.7755 15.5121 14.6226C15.5121 13.4698 16.4649 12.5165 17.6173 12.5165C18.7696 12.5165 19.7225 13.4698 19.7225 14.6226Z"
        fill={fill}
      />
      <path
        d="M21.1185 4.20257C16.8195 -0.830113 9.2629 -1.42871 4.2104 2.87234C3.72288 3.27141 3.27968 3.73699 2.8808 4.20257H21.1185Z"
        fill={fill}
      />
      <path
        d="M0 12.0066C0 12.2948 0.0221601 12.6052 0.0443201 12.8934H3.63425C4.78658 12.8934 5.98322 12.8934 7.06906 12.6052C8.66459 12.1839 10.0828 11.2749 11.5676 10.2994L11.6119 10.2773C12.0994 9.92254 12.6312 9.6565 13.2074 9.47913C13.9387 9.2796 14.6921 9.21309 15.4456 9.21309H23.7113C23.4454 8.0824 23.0243 6.99605 22.426 5.99838H1.59553C0.554002 7.81636 0 9.90037 0 12.0066Z"
        fill={fill}
      />
    </svg>
  );
};
